<template>
  <div id="common-header" class="common-header">

    <h1 class="header-title" v-bind:class="{'align-l':titleAlignL, 'align-c':titleAlignC, 'align-r':titleAlignR}" v-if="headerTitle" v-html='headerTitle'></h1>
    <h2 class="header-sub-title" v-if="headerSubTitle" v-html='headerSubTitle'></h2>

  </div>
</template>

<script>
/* eslint-enable */
export default {
  name: 'CommonHeader',
  data() {
    return {
      headerTitle: '',
      headerSubTitle: '',
      titleAlignL: false,
      titleAlignC: false,
      titleAlignR: false,
    }
  },
  inject: ['voteScreanInfo'],
  mounted(){ // ページが読み込まれたらする処理

    //投票画面情報ファイルを取得しテンプレートに反映
    var commonSettingInfo = this.voteScreanInfo[0].display_info.common_setting_information;

    if(commonSettingInfo.header_location == 1) {
      this.titleAlignL = true;
    } else if(commonSettingInfo.header_location == 2) {
      this.titleAlignC = true;
    } else if(commonSettingInfo.header_location == 3) {
      this.titleAlignR = true;
    }

    if(commonSettingInfo.header_title_type == 1 && commonSettingInfo.header_img_path) {
      this.headerTitle = '<img src="/'+commonSettingInfo.header_img_path+'" alt="ヘッダータイトル画像" />';
    } else {
      this.headerTitle = commonSettingInfo.header_title;
    }
    this.headerSubTitle = commonSettingInfo.header_sub_title;

  },
}
/* eslint-enable */
</script>
